module.exports = __webpack_public_path__ + "static/media/46.b94df72d.jpg";